<h2 mat-dialog-title>Edition pricing overview</h2>
<mat-dialog-content>
  @for (stairstep of stairsteps | keyvalue: noSortOrder; track stairstep) {
    <div class="stairstep-dialog-row">
      <span>{{ stairstep.key }}</span>
      <div>
        @if (stairstep.value.price && stairstep.value.price > 0) {
          <glxy-frequency
            [value]="stairstep.value.price | currencyWithoutUSD: currencyCode : 'en-US'"
            [form]="Form.SHORT"
            [align]="'end'"
            [frequency]="frequency"
            [size]="'regular'"
          ></glxy-frequency>
        }
        @if (!stairstep.value.price || stairstep.value.price === 0) {
          <span>{{ freeLabel }}</span>
        }
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions class="stairstep-actions-container">
  <button mat-flat-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>
